import { Core } from '../core';
import { PricelistDto, PricelistEntity } from './interfaces';

export const PricelistsStore = Core.Stores.create<PricelistEntity, PricelistDto>('/pricelists');
